export default __webpack_public_path__ + "static/media/1019.c4090b31.png";